import React from "react";
import { ISvg } from "../../../interfaces/svg";

const Svg: React.FC<ISvg> = ({ src, alt, className }) => {
  return <img className={className} src={src} alt={alt} />;
};

export default Svg;
